import { Helmet } from 'react-helmet-async'

const SITE = 'https://jarvis.yourproject.ai'

interface Props {
  title: string
  description: string
  path: string // e.g. "/privacy"
  noindex?: boolean
}

export default function Seo({ title, description, path, noindex }: Props) {
  const url = `${SITE}${path}`
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Helmet>
  )
}
